module.exports = __webpack_public_path__ + "fc19b9e3788e4f867d385ff8a6b8f180.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img5.png
// module id = 1324
// module chunks = 0